module.exports = {
    title: "Review Tags",
    crud: {
        create: "Create Tags",
        edit: "Edit Tags",
        tableTitle:"History",
    },
    table: {
        title: "Title",
        isPublic: "isPublic",
        actions: "Actions",
        columns:{
            title:"title",
            isPublic:"isPublic",
            actions:"actions",
        }
        // 
    },
    form: {
        title: "title"
    },
    validation: {
        required: {
            title: 'title is required'
        }
    },
}
